<template>
    <div>
        <label class="w-full"> Menu </label>
        <v-select v-model="menu" :options="menus" :clearable="false" class="mb-6" />
    </div>
</template>

<script>
    import firebase from '@/firebase/firebase'
    import vSelect from 'vue-select'
    import { mapState, mapMutations } from 'vuex'

    export default {
        components : {
            vSelect
        },

        data () {
            return {
                menus : []
            }
        },

        computed : {
            menu : {
                get () {
                    const selectedMenuIdFromDB = this.productInfo.productType.menuId

                    if(this.menus){
                        const selectedLocalMenuId = this.menus.find(a => a.id == selectedMenuIdFromDB)
                        return selectedLocalMenuId || ''
                    } else
                    return ''
                },
                set (menu) {
                    this.setMenu(menu.id)
                }
            },

            ...mapState('product', ['productInfo'])
        },

        methods : {
            async fetchMenus () {
                let companyId = this.$store.getters.getCompanyID 
                
                firebase.firestore().collection(`/company/${companyId}/menu`)
                    .onSnapshot((snapshot) => {
                        snapshot.docChanges().forEach(change => {
                            const data = change.doc.data()
                            // let obj = { ...change.doc.data(), ...{ id: change.doc.id } }
                            let obj = {
                                id : change.doc.id,
                                label : data.description
                            }

                            if (change.type === "added") {
                                this.addToMenu(obj)
                            }
                            if (change.type === "modified") {
                                this.changeMenu(obj)
                            }
                            // if (change.type === "removed") { }
                        })
                    })
            },

            addToMenu(menu) {
                this.menus = this.sortMenus(menu)
                this.setSelection(menu);
            },

            changeMenu (menuChanged) {
                for (let i = 0; i < this.menuData.length; i++){
                    if(this.menuData[i].id == menuChanged.id) {
                        this.$set(this.menuData, i, menuChanged)
                    }
                }

                this.menus = this.sortMenus()
            },

            sortMenus (menu = []) {
                let menus = [...this.menus, ...[menu]]

                if(menu.length == 0)
                    menus = [...this.menus]

                menus.sort((a,b) => {
                    if(a.hasOwnProperty('order') && b.hasOwnProperty('order')){
                        return a.order - b.order
                    }
                })

                return menus
            },

            setSelection (menu) {
                if (this.$route.query && this.$route.query.menuId && menu.id === this.$route.query.menuId)
                    this.menu = menu;
            },

            ...mapMutations('product', ['setMenu'])
        },

        async mounted () {
            await this.fetchMenus()
        }
    }
</script>